// new logic version3 17 feb
 /* eslint-disable */
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { db } from "../../firebase-config";
import { storage } from "../../firebase-config";
import {
  getDownloadURL,
  ref as ref_storage,
  uploadBytesResumable,
} from "firebase/storage";
import { toast } from "react-toastify";
import { ref, runTransaction, get, update,set } from "firebase/database";
import "./PatientItem.css";
import CryptoJS from "crypto-js";
import jsPDF from "jspdf"; // Import jsPDF for PDF creation
import Tooltip from "@mui/material/Tooltip";
import { logDoctorViewPrescription } from "./DoctorAuditLogs"; // deepa auditlogs
import { logDoctorUploadPrescription } from "./DoctorAuditLogs"; // deepa auditlogs

const encryptData = (data) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  if (!secretKey) {
    throw new Error("Secret key is not defined");
  }
  return CryptoJS.AES.encrypt(data, secretKey).toString();
};

const decryptData = (encryptedData) => {
  try {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.warn("Error decrypting data:", error);
    return encryptedData;
  }
};

const decryptDataIfNeeded = (data) => {
  if (typeof data === "string" && data.startsWith("U2FsdGVkX1")) {
    return decryptData(data);
  }
  return data;
};

const PatientItem = ({ patient, openUploadModalDirectly, onClose, onPrescriptionUpload }) => {
  const [showPopupPrescription, setShowPopupPrescription] = useState(false);
  const [prescriptionFiles, setPrescriptionFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const adminName1 = localStorage.getItem("adminName");

  useEffect(() => {
    if (openUploadModalDirectly && !patient.PrescriptionURL) {
      setShowPopupPrescription(true);
    }
  }, [openUploadModalDirectly, patient.PrescriptionURL]);

  const handlePrescriptionUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setPrescriptionFiles(files);
      console.log("Selected files:", files);
    }
  };

  const uploadPrescriptionAsPDF = async () => {
    if (prescriptionFiles.length === 0) {
      toast.error("No files selected for upload.", { position: "top-center" });
      return;
    }
    setIsUploading(true);

    // Declare latestScanKey so it's available throughout the function.
    let latestScanKey;

    
    // Get the patient record so we can check for legacy data.
    const patientRef = ref(db, `superadmin/admins/${adminName1}/patients/${patient.id}`);
    const patientSnapshot = await get(patientRef);
    const patientData = patientSnapshot.val();

    // If the patient version is "01" or "02", we have legacy data.




// if (patientData.Version === "01" || patientData.Version === "02") {
//   const legacyUpload = {
//     Prescription: patientData.Prescription && patientData.Prescription.trim() !== ""
//       ? [patientData.Prescription] 
//       : [],
//     PathPrescription: patientData.PathPrescription && patientData.PathPrescription.trim() !== ""
//       ? [patientData.PathPrescription] 
//       : [],
//     PrescriptionURL: patientData.PrescriptionURL && patientData.PrescriptionURL.trim() !== ""
//       ? [patientData.PrescriptionURL] 
//       : [],
//     Dicom_3D: patientData.Dicom_3D || "",
//     Dicom_3DURL: patientData.Dicom_3DURL || "",
//     FolderPath: patientData.FolderPath || "",
//     Path3D: patientData.Path3D || "",
//     Dicom_Report: patientData.Dicom_Report || "",
//     Dicom_ReportURL: patientData.Dicom_ReportURL || "",
//     StudyDate: patientData.StudyDate || "",
//     Type_of_Dicom_Data: patientData.Type_of_Dicom_Data || "",
//     Modality: patientData.Modality || "",
//     uploadtimetamp: patientData.Timestamp || "Not Available",
//   };

//   await update(patientRef, {
//     uploads: { "Scan 1": legacyUpload },
//     Version: "03",
//     Dicom_3D: null,
//     Dicom_3DURL: null,
//     FolderPath: null,
//     Path3D: null,
//     Dicom_Report: null,
//     Dicom_ReportURL: null,
//     StudyDate: null,
//     Type_of_Dicom_Data: null,
//     Modality: null,
//     Prescription: null,
//     PathPrescription: null,
//     PrescriptionURL: null,
//   });

//   latestScanKey = "Scan 1";
// }

if (patientData.Version === "01" || patientData.Version === "02") {
  const legacyUpload = {
    Prescription: patientData.Prescription && patientData.Prescription.trim() !== ""
      ? [patientData.Prescription] 
      : [],
    PathPrescription: patientData.PathPrescription && patientData.PathPrescription.trim() !== ""
      ? [patientData.PathPrescription] 
      : [],
    PrescriptionURL: patientData.PrescriptionURL && patientData.PrescriptionURL.trim() !== ""
      ? [patientData.PrescriptionURL] 
      : [],
    Dicom_3D: patientData.Dicom_3D || "",
    Dicom_3DURL: patientData.Dicom_3DURL || "",
    FolderPath: patientData.FolderPath || "",
    Path3D: patientData.Path3D || "",
    Dicom_Report: patientData.Dicom_Report || "",
    Dicom_ReportURL: patientData.Dicom_ReportURL || "",
    StudyDate: patientData.StudyDate || "",
    Type_of_Dicom_Data: patientData.Type_of_Dicom_Data || "",
    Modality: patientData.Modality || "",
    uploadtimetamp: patientData.Timestamp || "",
  
    PathReport: patientData.PathReport || "",
  };

  await update(patientRef, {
    uploads: { "Scan 1": legacyUpload },
    Version: "03",
    Dicom_3D: null,
    Dicom_3DURL: null,
    FolderPath: null,
    Path3D: null,
    Dicom_Report: null,
    Dicom_ReportURL: null,
    StudyDate: null,
    Type_of_Dicom_Data: null,
    Modality: null,
    Prescription: null,
    PathPrescription: null,
    PrescriptionURL: null,
    PathReport:null,

  });

  latestScanKey = "Scan 1";
}

    // ***** End Legacy Migration Logic *****

    // If legacy migration didn't happen, determine latestScanKey from existing uploads.
    if (!latestScanKey) {
      const uploadsRef = ref(db, `superadmin/admins/${adminName1}/patients/${patient.id}/uploads`);
      const snapshot = await get(uploadsRef);
      if (snapshot.exists()) {
        const uploads = snapshot.val();
        const scanKeys = Object.keys(uploads).filter((key) => key.startsWith("Scan"));
        if (scanKeys.length > 0) {
          const latestScanNumber = Math.max(
            ...scanKeys.map((key) => parseInt(key.split(" ")[1], 10))
          );
          latestScanKey = `Scan ${latestScanNumber}`;
        }
      }
      if (!latestScanKey) {
        latestScanKey = "Scan 1";
      }
    }

    // Get current scan data and determine the starting prescription index.
    const currentScanRef = ref(
      db,
      `superadmin/admins/${adminName1}/patients/${patient.id}/uploads/${latestScanKey}`
    );
    const currentScanData = (await get(currentScanRef)).val();
    let prescriptionIndex = 0;
    if (currentScanData && Array.isArray(currentScanData.Prescription)) {
      prescriptionIndex = currentScanData.Prescription.length;
    }

    // Partition the selected files into images and PDFs.
    const imageFiles = prescriptionFiles.filter((file) =>
      file.type.startsWith("image/")
    );
    const pdfFiles = prescriptionFiles.filter(
      (file) => file.type === "application/pdf"
    );

    // -------------------------------
    // 1. Process Image Files: Convert Images to a Single PDF
    // -------------------------------
    if (imageFiles.length > 0) {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: [595, 842],
      });

      for (let i = 0; i < imageFiles.length; i++) {
        const file = imageFiles[i];
        // Read the image file as a Data URL
        const imgData = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        const img = new Image();
        img.src = imgData;
        await new Promise((resolve) => {
          img.onload = () => {
            const aspectRatio = img.width / img.height;
            let imgWidth = pdf.internal.pageSize.getWidth() - 20;
            let imgHeight = imgWidth / aspectRatio;
            if (imgHeight > pdf.internal.pageSize.getHeight() - 20) {
              imgHeight = pdf.internal.pageSize.getHeight() - 20;
              imgWidth = imgHeight * aspectRatio;
            }
            pdf.addImage(
              imgData,
              "JPEG",
              (pdf.internal.pageSize.getWidth() - imgWidth) / 2,
              10,
              imgWidth,
              imgHeight
            );
            resolve();
          };
        });
        if (i < imageFiles.length - 1) pdf.addPage();
      }

      const pdfBlob = pdf.output("blob");
      const pdfFileName = `prescription${prescriptionIndex}.pdf`;
      prescriptionIndex++;

      const fileRef = ref_storage(
        storage,
        `superadmin/admins/${adminName1}/patients/${patient.id}/${pdfFileName}`
      );
      const uploadTask = uploadBytesResumable(fileRef, pdfBlob);

      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(`Image PDF upload is ${progress}% done`);
          },
          async (error) => {
            console.error("Upload failed:", error);
            toast.error("Failed to upload image PDF.", { position: "top-center" });
            // deepa auditlogs: Log failure event for prescription upload
            await logDoctorUploadPrescription({
              doctorName: adminName1 || "UnknownDoctor",
              patientId: patient.id,
              patientName: patient.FullName,
              prescriptionUrl: "",
              success: false,
              failure_reason: error.message || "Unknown error"
            });
            reject(error);
          },
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            const encryptedURL = encryptData(downloadURL);

           
          //  for preserving existing prescreptios node
           
          await runTransaction(currentScanRef, (currentData) => {
            if (!currentData) {
              currentData = {};
            }
          
            // Preserve existing Prescription data
            if (!Array.isArray(currentData.Prescription)) {
              currentData.Prescription = currentData.Prescription ? [currentData.Prescription] : [];
            }
          
            // Preserve existing PrescriptionURL data
            if (!Array.isArray(currentData.PrescriptionURL)) {
              currentData.PrescriptionURL = currentData.PrescriptionURL ? [currentData.PrescriptionURL] : [];
            }
          
            // Preserve existing PathPrescription data
            if (!Array.isArray(currentData.PathPrescription)) {
              currentData.PathPrescription = currentData.PathPrescription ? [currentData.PathPrescription] : [];
            }
          
            // Append new data
            currentData.Prescription.push(pdfFileName);
            currentData.PrescriptionURL.push(encryptedURL);
            currentData.PathPrescription.push(
              encryptData(`superadmin/admins/${adminName1}/patients/${patient.id}/${pdfFileName}`)
            );
          
            return currentData;
          });
          
            // deepa auditlogs: Log success event for prescription upload
            await logDoctorUploadPrescription({
              doctorName: adminName1 || "UnknownDoctor",
              patientId: patient.id,
              patientName: patient.FullName,
              prescriptionUrl: downloadURL,
              success: true
            });
            resolve();
          }
        );
      });
    }


    // -------------------------------
    // 2. Process PDF Files: Upload Them Directly
    // -------------------------------
    for (const file of pdfFiles) {
      const pdfFileName = `prescription${prescriptionIndex}.pdf`;
      prescriptionIndex++;

      const fileRef = ref_storage(
        storage,
        `superadmin/admins/${adminName1}/patients/${patient.id}/${pdfFileName}`
      );
      const uploadTask = uploadBytesResumable(fileRef, file);

      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(`Direct PDF upload is ${progress}% done`);
          },
          async (error) => {
            console.error("Upload failed:", error);
            toast.error("Failed to upload PDF.", { position: "top-center" });
            // deepa auditlogs: Log failure event for prescription upload
            await logDoctorUploadPrescription({
              doctorName: adminName1 || "UnknownDoctor",
              patientId: patient.id,
              patientName: patient.FullName,
              prescriptionUrl: "",
              success: false,
              failure_reason: error.message || "Unknown error"
            });
            reject(error);
          },
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            const encryptedURL = encryptData(downloadURL);            
            await runTransaction(currentScanRef, (currentData) => {
              if (!currentData) {
                currentData = {};
              }
              if (!currentData.Prescription) {
                currentData.Prescription = [];
              }
              if (!currentData.PrescriptionURL) {
                currentData.PrescriptionURL = [];
              }
              if (!currentData.PathPrescription || !Array.isArray(currentData.PathPrescription)) {
                currentData.PathPrescription = [];
              }
            
              currentData.Prescription.push(pdfFileName);
              currentData.PrescriptionURL.push(encryptedURL);
              currentData.PathPrescription.push(
                encryptData(`superadmin/admins/${adminName1}/patients/${patient.id}/${pdfFileName}`)
              );
            
              return currentData;
            });
            // deepa auditlogs: Log success event for prescription upload
            await logDoctorUploadPrescription({
              doctorName: adminName1 || "UnknownDoctor",
              patientId: patient.id,
              patientName: patient.FullName,
              prescriptionUrl: downloadURL,
              success: true
            });
            resolve();
          }
        );
      });
    }

  //Viniith Added 19-02-2025
    const storageSize = await calculateTotalStorageSize(prescriptionFiles);
    const adminStorageRef = ref(
      db,
      `superadmin/admins/${adminName1}/AdminStorageSize`
    );
    await set(adminStorageRef, storageSize);
    toast.success("Uploaded successfully.", { position: "top-center" });
    setPrescriptionFiles([]);
    setIsUploading(false);
    setShowPopupPrescription(false);
    
    // Call the refresh callback to update parent component
    if (onPrescriptionUpload && typeof onPrescriptionUpload === 'function') {
      onPrescriptionUpload(patient.id);
    }
  };


  //Viniith Added 19-02-2025
  const calculateTotalStorageSize = async (files) => {
    let totalSize = 0;

    files.forEach((file) => {
      console.log(
        `Adding Prescription File: ${file.name}, Size: ${file.size} bytes`
      );
      totalSize += file.size;
    });

    const adminStorageRef = ref(
      db,
      `superadmin/admins/${adminName1}/AdminStorageSize`
    );
    let currentStorageSize = 0;

    try {
      const adminStorageSnapshot = await get(adminStorageRef);
      if (adminStorageSnapshot.exists()) {
        const storedSize = adminStorageSnapshot.val();
        console.log(`Existing AdminStorageSize (Raw): ${storedSize}`);
        currentStorageSize = parseFormattedSizeToBytes(storedSize);
        console.log(
          `Existing AdminStorageSize in Bytes: ${currentStorageSize} bytes`
        );
      }
    } catch (error) {
      console.error("Error fetching AdminStorageSize:", error);
    }

    const updatedStorageSizeBytes = currentStorageSize + totalSize;
    console.log(
      `Updated AdminStorageSize in Bytes: ${updatedStorageSizeBytes} bytes`
    );
    return formatFileSize(updatedStorageSizeBytes);
  };

  // Utility: format bytes -> human-readable string
  const formatFileSize = (size) => {
    if (size < 1024) return `${size}B`; // bytes
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)}KB`; // KB
    if (size < 1024 * 1024 * 1024)
      return `${(size / (1024 * 1024)).toFixed(2)}MB`; // MB
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`; // GB
  };

  const parseFormattedSizeToBytes = (formatted) => {
    // Remove any spaces between the number and the unit
    const normalized = formatted.replace(/\s+/g, ""); // Remove all whitespace
    const sizePattern = /^(\d+(\.\d+)?)(KB|MB|GB|B)$/i; // Match without spaces
    const match = normalized.match(sizePattern);

    if (!match) {
      return 0;
    }

    const value = parseFloat(match[1]); // e.g., 2, 4.53
    const unit = match[3].toUpperCase(); // e.g., "MB", "KB"

    switch (unit) {
      case "B":
        return value;
      case "KB":
        return value * 1024;
      case "MB":
        return value * 1024 * 1024;
      case "GB":
        return value * 1024 * 1024 * 1024;
      default:
        return 0;
    }
  };

  const closeModal = () => {
    setShowPopupPrescription(false);
    setPrescriptionFiles([]);
    setIsUploading(false);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div key={patient.id}>
      {patient.Prescription &&
        typeof patient.Prescription === "string" &&
        patient.Prescription.trim() !== "" && (
          <div key="legacy-prescription" style={{ marginBottom: "10px" }}>
            {/* <Tooltip title="View Prescription" arrow>
              <span style={{ color: "blue", fontStyle: "italic" }}>
                {decryptDataIfNeeded(patient.Prescription)}
              </span>
            </Tooltip> */}
          </div>
        )}


      {patient.uploads ? (
        Object.keys(patient.uploads)
          .filter((key) => key.startsWith("Scan"))
          .map((scanKey) => {
            const scan = patient.uploads[scanKey];
            if (scan.Prescription) {
              if (Array.isArray(scan.Prescription)) {
                return scan.Prescription.map((prescription, index) => (
                  <div key={`${scanKey}-${index}`} style={{ marginBottom: "10px" }}>
                    <Tooltip title={'View Prescription'} arrow>
                      <span
                        onClick={async () => {
                          const decryptedUrl = decryptDataIfNeeded(scan.PrescriptionURL[index]);
                          try {
                            window.open(decryptedUrl, "_blank");
                            // deepa auditlogs: Log success event for prescription view
                            await logDoctorViewPrescription({
                              doctorName: adminName1 || "UnknownDoctor",
                              patientId: patient.id,
                              patientName: patient.FullName,
                              prescriptionUrl: decryptedUrl,
                              success: true
                            });
                          } catch (error) {
                            // deepa auditlogs: Log failure event for prescription view
                            await logDoctorViewPrescription({
                              doctorName: adminName1 || "UnknownDoctor",
                              patientId: patient.id,
                              patientName: patient.FullName,
                              prescriptionUrl: decryptedUrl,
                              success: false,
                              failure_reason: error.message || "Unknown error"
                            });
                            console.error("Failed to view prescription:", error);
                          }
                        }}
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "blue",
                          }}
                        >
                          {prescription}
                        </span>
                      </span>
                    </Tooltip>
                  </div>
                ));
              }
            }
            return null;
          })
      ) : (
        <p>No prescriptions available.</p>
      )}

      <div style={{ marginTop: "10px" }}>
        <Tooltip title="Add Prescription" arrow>
          <span
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={() => setShowPopupPrescription(true)}
          >
            ADD Prescription
          </span>
        </Tooltip>
      </div>

      {showPopupPrescription && (
        <Modal isOpen={showPopupPrescription} className="custom-modal-upload-prescription">
          <h6 className="modal-title-prescription">
            Upload Prescription - {patient.FullName}
          </h6>
          <div className="modal-input-prescription">
            <input
              type="file"
              id={`files-${patient.id}`}
              name={`files-${patient.id}`}
              onChange={handlePrescriptionUpload}
              accept=".jpg,.jpeg,.png,.pdf"
              multiple
              required
            />
          </div>
          <button
            className="modal-button-prescription upload"
            onClick={uploadPrescriptionAsPDF}
            disabled={prescriptionFiles.length === 0 || isUploading}
          >
            {isUploading ? "Uploading..." : "Upload "}
          </button>
          <button className="modal-button-prescription cancel" onClick={closeModal}>
            Cancel
          </button>
        </Modal>
      )}
    </div>
  );
};

export default PatientItem;
